class GallerySlider {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('.gallery-slider__track');
    if (!this.track) return;

    this.slides = Array.from(this.track.querySelectorAll('.gallery-slider__slide'));
    this.prevBtn = section.querySelector('.gallery-slider__arrow--prev');
    this.nextBtn = section.querySelector('.gallery-slider__arrow--next');
    this.dots = Array.from(section.querySelectorAll('.gallery-slider__dot'));

    this.autoplay = section.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(section.dataset.autoplaySpeed, 10) || 5000;
    this.autoplayTimer = null;

    this.bindEvents();
    this.updateControls();

    if (this.autoplay && this.slides.length > 1) {
      this.startAutoplay();
    }
  }

  bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.pauseAutoplay();
        this.scrollByOne(-1);
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.pauseAutoplay();
        this.scrollByOne(1);
      });
    }

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.pauseAutoplay();
        const index = parseInt(dot.dataset.index, 10);
        this.scrollToSlide(index);
      });
    });

    this.track.addEventListener(
      'scroll',
      () => {
        window.clearTimeout(this.scrollTimeout);
        this.scrollTimeout = window.setTimeout(() => this.updateControls(), 100);
      },
      { passive: true }
    );

    this.section.addEventListener('mouseenter', () => this.pauseAutoplay());
    this.section.addEventListener('mouseleave', () => {
      if (this.autoplay) this.startAutoplay();
    });

    window.addEventListener('resize', () => this.updateControls());
  }

  slideWidth() {
    return this.slides[0] ? this.slides[0].getBoundingClientRect().width + 16 : 0;
  }

  scrollByOne(direction) {
    this.track.scrollBy({ left: direction * this.slideWidth(), behavior: 'smooth' });
  }

  scrollToSlide(index) {
    const target = this.slides[index];
    if (!target) return;
    this.track.scrollTo({ left: target.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
  }

  currentIndex() {
    const scrollLeft = this.track.scrollLeft;
    const width = this.slideWidth();
    if (!width) return 0;
    return Math.round(scrollLeft / width);
  }

  updateControls() {
    const maxScroll = this.track.scrollWidth - this.track.clientWidth - 2;

    if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 0;
    if (this.nextBtn) this.nextBtn.disabled = this.track.scrollLeft >= maxScroll;

    if (this.dots.length) {
      const active = this.currentIndex();
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
    }
  }

  startAutoplay() {
    this.pauseAutoplay();
    this.autoplayTimer = window.setInterval(() => {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth - 2;
      if (this.track.scrollLeft >= maxScroll) {
        this.track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        this.scrollByOne(1);
      }
    }, this.autoplaySpeed);
  }

  pauseAutoplay() {
    if (this.autoplayTimer) {
      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }
}

function initGallerySliders() {
  document.querySelectorAll('.gallery-slider').forEach((section) => {
    if (!section.dataset.gsInitialized) {
      new GallerySlider(section);
      section.dataset.gsInitialized = 'true';
    }
  });
}

document.addEventListener('DOMContentLoaded', initGallerySliders);
document.addEventListener('shopify:section:load', initGallerySliders);
